export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14963.e8619a6a.jpg";